import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/purchaseNotices';
const productThumb = 'https://cdn.magicpatterns.com/uploads/6gR3M45KrWU7rc7Q17t5E1/Mockup_italiano_floral_con_sello_dorado.png';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchaseNotice() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed || purchaseNotices.length === 0) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_FOR : index === 0 ? FIRST_DELAY : GAP);
    return () => window.clearTimeout(timer);
  }, [visible, index, dismissed]);
  const handleExitComplete = () => {
    setIndex(current => (current + 1) % purchaseNotices.length);
  };
  const notice = purchaseNotices[index % purchaseNotices.length];
  return <div aria-live="polite" className="pointer-events-none fixed inset-x-3 bottom-3 z-40 flex justify-start sm:inset-x-auto sm:bottom-5 sm:left-5" data-id="element-285" data-mp="czu52qoap0ae">
      <AnimatePresence onExitComplete={handleExitComplete} data-id="element-286" data-mp="8xfm86kmm0j4">
        {visible && !dismissed && notice && <motion.div key={`${notice.name}-${index}`} role="status" initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-xl border border-amber-400/70 bg-white p-3 pr-9 shadow-lg" data-id="element-287" data-mp="mwp3zaohd2p7">
            <img src={productThumb} alt="" className="h-12 w-12 shrink-0 rounded-md bg-amber-50 object-contain" draggable={false} data-id="element-288" data-mp="3uio4nx2sylye" />
            <div className="min-w-0 text-sm leading-snug" data-id="element-289" data-mp="38z5j4w5vy5f">
              <p className="text-stone-900" data-id="element-290" data-mp="7bm2fk7ow99h">
                <span className="font-semibold" data-id="element-291" data-mp="7au7mblx2fk9">{notice.name}</span> da {notice.location}
              </p>
              <p className="text-stone-700" data-id="element-292" data-mp="h2gtd1vvrx19">
                ha acquistato il <span className="font-semibold text-emerald-800" data-id="element-293" data-mp="h1yl16vy1scz">Kit Completo Fiori di Bach™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-stone-500" data-id="element-294" data-mp="m3nysuajwk4r">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-emerald-600" aria-hidden="true" data-id="element-295" data-mp="r1fr3pf3y89h" />
                {notice.timeAgo}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="absolute right-2 top-2 rounded-md p-1 text-stone-400 transition-colors duration-150 ease-out hover:bg-stone-100 hover:text-stone-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" data-id="element-296" data-mp="2sssw0eh2sg5j">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-297" data-mp="2kibxvrkxm3it" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}